<ng-container *ngIf="isSlideWindow; else onlyTable">
    <n-slide-window  width="7rem" [visible]="windowVisible" [showMask]="true" (onHide)="close()">
        <n-header>
            <h1>{{title}}</h1>
        </n-header>

        <n-data-table #dt
            [id]="tableId"
            style="height: 100%;"
            [data]="tableData"
            [config]="tableConfig"
            [columnDefs]="tableColumnDefs">
        </n-data-table>

        <n-footer>
            <button id="type-path-slide-window-close-btn"
                nButton
                [label]="i18n.closeBtn"
                (click)="hide()">
            </button>
        </n-footer>
    </n-slide-window>
</ng-container>

<ng-template #onlyTable>
    <n-data-table #dt
        [id]="tableId"
        style="height: 2.9rem; width: 97%;"
        [data]="tableData"
        [config]="tableConfig"
        [columnDefs]="tableColumnDefs">
    </n-data-table>
</ng-template>
